import React, { useEffect, useMemo, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./index.css";

const testimonials = [
  {
    name: "HAAKON HELLING",
    text: "I think the OxfordMUN India is the best and greatest conference I’ve ever been to",
    image: "/assets/images/OxfordMunNew/Haakon.png",
  },
  {
    name: "ALBANE GODEST",
    text: "I really liked trying a new cultural and feeling really part of a new culture, a new history, and background, it was really amazing.",
    image: "/assets/images/OxfordMunNew/Albane.png",
  },
  {
    name: "OTTO LEONARDO JENDREK",
    text: "I was totally new to me but I met great people they were really kind, I learnt so many new things I really enjoyed it.",
    image: "/assets/images/OxfordMunNew/Otto.png",
  },
];

function Testimonial({ isMobile }) {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [shouldShowNavigation, setShouldShowNavigation] = useState(true);
  const totalSlides = testimonials.length;

  const navConfig = {
    prevEl: `.swiper-button-prev-${
      isMobile ? "mobile" : "desktop"
    }-testimonials`,
    nextEl: `.swiper-button-next-${
      isMobile ? "mobile" : "desktop"
    }-testimonials`,
  };

  // 🔁 When `isMobile` changes, re-bind swiper navigation
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params?.navigation) {
      const swiper = swiperRef.current;

      swiper.params.navigation.prevEl = navConfig.prevEl;
      swiper.params.navigation.nextEl = navConfig.nextEl;

      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [isMobile]);

  useEffect(() => {
    const updateNavigationVisibility = () => {
      const width = window.innerWidth;
      const slidesPerView = width >= 1024 ? 3 : width >= 900 ? 2 : 1;
      setShouldShowNavigation(testimonials.length > slidesPerView);
    };

    updateNavigationVisibility(); // Run on mount
    window.addEventListener("resize", updateNavigationVisibility);

    return () =>
      window.removeEventListener("resize", updateNavigationVisibility);
  }, []);

  return (
    <section className="testimonials-section" key="testimonials_section">
      <h2 className="testimonials-title">TESTIMONIALS</h2>
      {/* Custom Bottom Controls */}
      <div className="custom-bottom-nav-mobile">
        <div className="custom-arrow swiper-button-prev-mobile-testimonials">
          &#8592;
        </div>
        <div className="slide-counter">
          {currentSlide} / {totalSlides}
        </div>
        <div className="custom-arrow swiper-button-next-mobile-testimonials">
          &#8594;
        </div>
      </div>
      <div className="testimonials-container">
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          breakpoints={{
            // 1440: { slidesPerView: 4, spaceBetween: 40 },
            1024: { slidesPerView: 3, spaceBetween: 30 },
            900: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 1, spaceBetween: 10 },
          }}
          modules={[Navigation, Autoplay, A11y]}
          // navigation
          navigation={navConfig}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = navConfig.prevEl;
            swiper.params.navigation.nextEl = navConfig.nextEl;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          onSlideChange={(swiper) => {
            setCurrentSlide(swiper.realIndex + 1);
          }}
          autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
          loop
        >
          {testimonials.map((item, idx) => (
            <SwiperSlide key={idx}>
              <div className="testimonial-card" key={idx}>
                <div className="testimonial-img-bg">
                  <div className="testimonial-quote">
                    <span>
                      <img src="/assets/images/OxfordMunNew/double_commoa.svg" />
                    </span>
                    <div className="testimonial-content">
                      <span className="testimonial-name">{item.name}</span>
                      <p className="testimonial-text">{item.text}</p>
                    </div>
                  </div>
                </div>
                <img
                  src={item.image}
                  alt={item.name}
                  className="testimonial-img"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Custom Bottom Controls */}
        {shouldShowNavigation && (
          <div className="custom-bottom-nav">
            <div className="custom-arrow swiper-button-prev-desktop-testimonials">
              &#8592;
            </div>
            <div className="slide-counter">
              {currentSlide} / {totalSlides}
            </div>
            <div className="custom-arrow swiper-button-next-desktop-testimonials">
              &#8594;
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Testimonial;
